export const MOBILE_WIDTH = 768;
export const TINY_MOBILE_WIDTH = 600;
export const PAD_WIDTH = 1200;
export const PAD_WIDTH_SMALL = 1024;

// todo: something like Angular?  Breakpoint detection?
export function isMobile() {
    return window.innerWidth < MOBILE_WIDTH;
}

// todo: something like Angular?  Breakpoint detection?
export function isTinyMobile() {
    return window.innerWidth <= TINY_MOBILE_WIDTH;
}

// todo: something like Angular?  Breakpoint detection?
export function isPad() {
    return window.innerWidth < PAD_WIDTH;
}

export function isPadSmall() {
    return window.innerWidth < PAD_WIDTH_SMALL;
}